/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Facts_LanguagesInputs */

const en_vc_facts_languages = /** @type {(inputs: Vc_Facts_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interface`)
};

const zh_vc_facts_languages = /** @type {(inputs: Vc_Facts_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`界面语言`)
};

/**
* | output |
* | --- |
* | "Interface" |
*
* @param {Vc_Facts_LanguagesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_facts_languages = /** @type {((inputs?: Vc_Facts_LanguagesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Facts_LanguagesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_facts_languages(inputs)
	return zh_vc_facts_languages(inputs)
});
export { vc_facts_languages as "vc.facts.languages" }